import MyTabs from '../../../components/MyTabs';
import Preface from './Preface';
import Specifications from './Specifications';

const Introduction = (props) => {
  
    const tabs = [
        { id: "preface", title: "Preface", Component: Preface },
        { id: "Specifications", title: "Specifications" , Component: Specifications},
      ];

return (
    <>
        <MyTabs list={tabs}/>
    </>
)
};

export default Introduction;